export const BiCoSupportIcon = ({ height = '22', width = '22', className = '' }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M10.0989 2.57948C10.1382 2.3692 10.2497 2.17927 10.4143 2.0426C10.5789 1.90593 10.786 1.83112 11 1.83112C11.2139 1.83112 11.4211 1.90593 11.5856 2.0426C11.7502 2.17927 11.8618 2.3692 11.901 2.57948L12.8645 7.67431C12.9329 8.03653 13.1089 8.36971 13.3696 8.63037C13.6302 8.89102 13.9634 9.06705 14.3256 9.13548L19.4205 10.0989C19.6307 10.1382 19.8207 10.2498 19.9573 10.4143C20.094 10.5789 20.1688 10.7861 20.1688 11C20.1688 11.2139 20.094 11.4211 19.9573 11.5856C19.8207 11.7502 19.6307 11.8618 19.4205 11.9011L14.3256 12.8645C13.9634 12.9329 13.6302 13.1089 13.3696 13.3696C13.1089 13.6302 12.9329 13.9634 12.8645 14.3256L11.901 19.4205C11.8618 19.6308 11.7502 19.8207 11.5856 19.9574C11.4211 20.094 11.2139 20.1688 11 20.1688C10.786 20.1688 10.5789 20.094 10.4143 19.9574C10.2497 19.8207 10.1382 19.6308 10.0989 19.4205L9.13546 14.3256C9.06703 13.9634 8.891 13.6302 8.63035 13.3696C8.36969 13.1089 8.03651 12.9329 7.67429 12.8645L2.57946 11.9011C2.36918 11.8618 2.17925 11.7502 2.04258 11.5856C1.90591 11.4211 1.8311 11.2139 1.8311 11C1.8311 10.7861 1.90591 10.5789 2.04258 10.4143C2.17925 10.2498 2.36918 10.1382 2.57946 10.0989L7.67429 9.13548C8.03651 9.06705 8.36969 8.89102 8.63035 8.63037C8.891 8.36971 9.06703 8.03653 9.13546 7.67431L10.0989 2.57948Z"
        stroke="#DFF800"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 1.83331V5.49998"
        stroke="#DFF800"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1667 3.66669H16.5"
        stroke="#DFF800"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.66667 20.1667C4.67919 20.1667 5.5 19.3459 5.5 18.3333C5.5 17.3208 4.67919 16.5 3.66667 16.5C2.65414 16.5 1.83333 17.3208 1.83333 18.3333C1.83333 19.3459 2.65414 20.1667 3.66667 20.1667Z"
        stroke="#DFF800"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
